import type { TaskFile } from '@/task-manager/entities/task-file';

import type { FileRead } from '../fetch-client';

export function taskFileMapper(dataFile: FileRead): TaskFile {
  return {
    id: dataFile.file_id,
    name: dataFile.file_name,
    extension: dataFile.file_extension,
    uploadedAt: new Date(dataFile.uploaded_at),
  };
}
